import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { ProgressCircle } from "@heroui/react";

type Secure3dsSearch = {
  PaReq: string;
  Md: string;
  Action: string;
};

export const Route = createFileRoute("/payments/secure3ds")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): Secure3dsSearch => ({
    PaReq: String(search.PaReq ?? ""),
    Md: String(search.Md ?? ""),
    Action: String(search.Action ?? ""),
  }),
});

function RouteComponent() {
  const { PaReq, Md, Action } = Route.useSearch();
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    formRef.current?.submit();
  }, []);

  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center gap-6">
      <form ref={formRef} action={Action} method="post" target="_self">
        <input name="PaReq" type="hidden" value={PaReq} />
        <input name="MD" type="hidden" value={Md} />
      </form>

      <ProgressCircle className="text-[#571B23]" isIndeterminate />

      <h1 className="text-center text-xl font-semibold leading-relaxed">
        Дождитесь ответа!
        <br />
        Жауабын күтіңіз!
        <br />
        Wait for an answer!
      </h1>
    </div>
  );
}
